import { render, staticRenderFns } from "./TownInfo.vue?vue&type=template&id=5f83927e&scoped=true"
import script from "./TownInfo.vue?vue&type=script&lang=js"
export * from "./TownInfo.vue?vue&type=script&lang=js"
import style0 from "./TownInfo.vue?vue&type=style&index=0&id=5f83927e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f83927e",
  null
  
)

export default component.exports